import { useCallback, useState } from 'react';

/**
 * Local open/title/body state for {@link StatusErrorDialog}.
 *
 * Kept out of Redux so ProjectDetail, AddProjectToDealForm, and status pills do not fight over a
 * single global modal the way InfoDialog does.
 *
 * @returns {{
 *   isOpen: boolean,
 *   title: string,
 *   statusError: string,
 *   showStatusError: (title: string, message: string) => void,
 *   closeStatusError: () => void,
 * }}
 */
export const useStatusErrorDialog = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [title, setTitle] = useState('');
  const [statusError, setStatusError] = useState('');

  /**
   * Opens the dialog with a title and plain-text body (newlines preserved by StatusErrorDialog).
   *
   * @param {string} nextTitle
   * @param {string} message
   */
  const showStatusError = useCallback((nextTitle, message) => {
    setTitle(nextTitle || 'Error');
    setStatusError(message || '');
    setIsOpen(true);
  }, []);

  const closeStatusError = useCallback(() => {
    setIsOpen(false);
  }, []);

  return {
    isOpen,
    title,
    statusError,
    showStatusError,
    closeStatusError,
  };
};
